<!--登录界面-->
<template>
  <div class="cont_principal">
    <h1 class="title" style="color: #fff">河蟹产品管理后台</h1>
    <div class="cont_centrar">
      <div class = "top">
        <h2 class="top_set1">欢迎来到管理后台页面，请登陆：</h2>
      </div>
      <div class="cont_login">
        <el-form action="" class="submit_form">
          <div class="cont_tabs_login">
            <ul class='ul_tabs'>
              <li class="active"><a href="#" @click="sign_in()">登录</a>
                <span class="linea_bajo_nom"></span>
              </li>
              <li><a href="#" @click="sign_up()">注册</a><span class="linea_bajo_nom"></span>
              </li>
            </ul>
          </div>
          <div class="cont_text_inputs">
            <el-input type="text"  class="input_form_sign d_block active_inp" placeholder="请输入用户名"  v-model="username"  />
            <el-input type="password" class="input_form_sign d_block  active_inp" placeholder="请输入密码"  v-model="password"/>
            <el-input type="password" class="input_form_sign" placeholder="确认密码" v-model="confWord" />
          </div>
          <div class="role_style">
              <el-radio v-model="role" label="role_admin">商户</el-radio>
              <!-- <el-radio v-model="role" label="role_boss">商户</el-radio> -->
          </div>
          <div class="cont_btn">
            <button class="btn_sign" @click="submit">登录</button>
          </div>
        </el-form>
      </div>
      <div class="right">
        <div class="right_img">
                <img src="https://www.njzhny.com/shopping/img/loginpicture.4c357767.png" width="500" height="375">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../http/auth'
export default {
  name: 'Login',
  data () {
    return {
      role: 'role_admin', /* 用户角色,商户 */
      /* 表单数据 */
      username: '', // 用户名
      password: '', // 密码
      confWord: '' // 确认密码,不传入后端,前端做逻辑判断
    }
  },
  methods: {
    /* 阻止表单的默认行为--->提交表单后刷新网页
   * 解决问题:登录注册提交表单后会自动刷新,无法触发submit(),取消表单默认行为,并在submit函数最开始调用次函数,即可解决问题
   * */
    preventFormAction () {
      let form = document.querySelector('.submit_form')
      form.onsubmit = () => {
        return false
      }
    },
    /* 注册函数 */
    sign_up () {
      let inputs = document.querySelectorAll('.input_form_sign')
      // 显示单选框
      document.querySelector('.role_style').style.display = 'block'
      document.querySelectorAll('.ul_tabs > li')[0].className = ''
      document.querySelectorAll('.ul_tabs > li')[1].className = 'active'
      for (let i = 0; i < inputs.length; i++) {
        if (i === 2) {
        } else {
          document.querySelectorAll('.input_form_sign')[i].className = 'input_form_sign d_block '
        }
      }
      setTimeout(function () {
        for (let d = 0; d < inputs.length; d++) {
          document.querySelectorAll('.input_form_sign')[d].className = 'input_form_sign d_block active_inp'
        }
      }, 10)
      document.querySelector('.btn_sign').innerHTML = '注册'
    },
    /* 登录函数 */
    sign_in () {
      let inputs = document.querySelectorAll('.input_form_sign')
      document.querySelector('.role_style').style.display = 'none'
      document.querySelectorAll('.ul_tabs > li')[0].className = 'active'
      document.querySelectorAll('.ul_tabs > li')[1].className = ''
      for (let i = 0; i < inputs.length; i++) {
        switch (i) {
          case 1:
            console.log(inputs[i].name)
            break
          case 2:
            console.log(inputs[i].name)
            break
          default:
            document.querySelectorAll('.input_form_sign')[i].className = 'input_form_sign d_block'
        }
      }
      setTimeout(function () {
        for (let d = 0; d < inputs.length; d++) {
          switch (d) {
            case 1:
              console.log(inputs[d].name)
              break
            case 2:
              console.log(inputs[d].name)
              break
            default:
              document.querySelectorAll('.input_form_sign')[0].className = 'input_form_sign d_block active_inp'
              document.querySelectorAll('.input_form_sign')[1].className = 'input_form_sign d_block active_inp'
          }
        }
      }, 10)

      setTimeout(function () {
        for (let d = 0; d < inputs.length; d++) {
          switch (d) {
            case 1:
              console.log(inputs[d].name)
              break
            case 2:
              console.log(inputs[d].name)

              break
            default:
              document.querySelectorAll('.input_form_sign')[2].className = 'input_form_sign'
          }
        }
      }, 150)
      document.querySelector('.btn_sign').innerHTML = '登录'
    },
    /* 表单提交函数 */
    async submit () {
      this.preventFormAction()
      let value = document.querySelector('.btn_sign').innerHTML
      // console.log('xixi' + value)
      let loginData = {
        username: this.username, // 用户名
        password: this.password // 密码
      }
      let signInData = {
        password: this.password, // 密码
        role: this.role, // 用户角色
        username: this.username // 用户名

      }
      // console.log(signInData)
      /* 登录请求 */
      if (value === '登录') {
        if (!this.password || !this.username) {
          this.$message({
            message: '用户名或密码不能为空',
            type: 'warning'
          })
          return
        }

        let res = await request.login(loginData)
        // console.log(res)
        if (res.data) {
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          window.sessionStorage.setItem('token', res.data.token)
          window.sessionStorage.setItem('username', res.data.username)
          // window.sessionStorage.setItem('role', res.data.role)
          this.$router.push('/Home')

          // 实现按照不同角色进行跳转
          // if (window.sessionStorage.getItem('role') === 'role_admin') {
          //   this.$router.push('/Home')
          // } else if (window.sessionStorage.getItem('role') === 'role_boss') {
          //   this.$router.push('/bossHome')
          // }
        } else {
          this.$message({
            message: '账号或密码错误',
            type: 'error'
          })
        }
      }
      if (value === '注册') {
        if (!this.password || !this.username || !this.confWord) {
          this.$message({
            message: '请完善未填信息',
            type: 'warning'
          })
          return
        }
        /* 注册请求 */
        let ret = await request.register(signInData)
        // console.log(ret)
        if (ret.msg === 'SUCCESS') {
          this.$message({
            message: '注册成功',
            type: 'success'
          })
          location.reload() // 刷新当前页面,回到登录状态
        } else {
          this.$message({
            message: '注册失败',
            type: 'error'
          })
        }
      }
    }
  }
}
</script>

<style scoped>
  * {
    margin: 0px auto;
    padding: 0px;
    font-family: 'Open Sans', "华文楷体";
  }
  .cont_principal {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #222C38;
    background-size: 100%;
    overflow: hidden;
  }

  .cont_centrar {
    position: absolute;
    left:50%;
    top:50%;
    margin-left: -400px;
    margin-top: -200px;
  }

  .cont_centrar {
    position: relative;
    width: 900px;
    height: 480px;
    float: left;
    background-image: linear-gradient(-226deg, #F5F5F5 8%, #F5F5F5 100%);
    border-radius: 0px;
    transition: all 0.5s;
    box-shadow: 10px 10px 5px #888888;
  }

  .top {
    position: absolute;
    width: 400px;
    height: 60px;
    left: 25px;
    top: 20px;
  }
  .right {
    position: absolute;
    width: 400px;
    left: 400px;
    top: 0px  ;

  }
  .right_img {
    position: relative;
    width: 100%;
    top: 50px;
  }
  .cent_active {
    box-shadow: 5px 5px 10px 0px rgba(0,0,0,0.21);
  }

  .cont_login {
    position: absolute;
    width: 400px;
    height: 480px;
    left: 0px;
    top: 0px;
  }
  .cont_tabs_login {
    position: relative;
    top: 72px;
    height: 100px;
    float: left;
    width: 100%;
  }

  .ul_tabs > li {
    position: relative;
    float: left;
    width: 50%;
    list-style: none;
    text-align: center;
  }

  .ul_tabs > li > a  {
    text-decoration: none;
    font-family: 微软雅黑;
    font-size: 20px;
    color: #999;
    line-height: 14px;
    padding: 20px;
    display: block;
    transition: all 0.5s;
  }

  .ul_tabs > .active > a  {
    color: #1f3533;
  }

  .linea_bajo_nom {
    position: relative;
    width: 100%;
    float: left;
    background-color: rgb(244, 248, 248);
    height: 2px;
  }

  .active .linea_bajo_nom {
    position: relative;
    width: 100%;
    float: left;
    background-color: #1f3533;
    height: 2px;
  }

  .cont_text_inputs {
    position: relative;
    top: 20px;
    float: left;
    width: 300px;
    margin-top: 0px;
    box-sizing: border-box;
    background-origin: padding-box;
  }

  .role_style {
    position: absolute;
    font-size: 20px;
    top: 300px;
    left: 30px;
    display: none;
    text-align: center;
}

  .input_form_sign {
    position: relative;
    float: left;
    width: 100%;
    border: none;
    background-color: transparent;
    font-size: 20px;
    outline: none;
    transition: all 0.5s;
    height: 0px;
    margin: 20px;
    padding: 10px 0px;
    opacity: 0;
    display: none;
  }

  .active_inp {
    font-size: 20px;
    margin: 5% 5% ;
    padding: 10px 10px;
    opacity: 1;
    height: 5px;
  }
  .input_form_sign:focus {
    border-bottom: 1px solid #409EFF ;}

  .link_forgot_pass {
    position: relative;
    margin-top: 0px;
    margin-left: 30%;
    text-decoration: none;
    color: #999;
    font-size: 13px;
    display: none;
    float: left;
    transition: all 0.5s;
  }

  .cont_btn {
    position: relative;
    float: center;
    top: 40px;
    left: 10px;
  }

  .btn_sign {
    background: #409EFF;
    border-radius: 8px;
    padding: 15px 30px;
    border: none;
    color: #fff;
    font-size: 20px;
    position: relative;
    float: left;
    margin-left: 80px;
    margin-top: 30px;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .d_none {
    display: none;
  }

  .d_block {
    display: block;
  }

  .cont_text_inputs > input:nth-child(1){
    transition-delay: 0.2s;
  }

  .cont_text_inputs > input:nth-child(2){
    transition-delay: 0.4s;
  }
  .cont_text_inputs > input:nth-child(3){
    transition-delay: 0.6s;
  }
  .cont_text_inputs > input:nth-child(4){
    transition-delay: 0.8s;
  }
  .title{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 14%;
    line-height: 44px;
    font-size: 45px;
    text-shadow: 5px 5px 5px #C9C9C9;
  }
</style>
